import React from 'react';
import type { IconProps } from '../types';

export const IconMPR = (props: IconProps) => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0098 1.06677C12.1066 1.02325 12.2176 1.02325 12.3145 1.06677L23.2588 5.99353C23.3919 6.05352 23.4774 6.18643 23.4775 6.3324V18.7689C23.4775 18.9022 23.4057 19.025 23.29 19.0912L12.3467 25.3529C12.2323 25.4183 12.0919 25.4183 11.9775 25.3529L1.03418 19.0912C0.918491 19.025 0.84668 18.9022 0.84668 18.7689V6.3324C0.846865 6.18643 0.932336 6.05352 1.06543 5.99353L12.0098 1.06677Z"
      stroke="white"
      strokeWidth="1.36932"
      strokeLinecap="round"
    />
    <path
      d="M12.314 24.7384V11.7767L1.65527 6.32904"
      stroke="white"
      strokeWidth="1.36932"
      strokeLinecap="round"
    />
    <path
      d="M12.3145 11.9625L22.5672 6.32904"
      stroke="white"
      strokeWidth="1.36932"
      strokeLinecap="round"
    />
  </svg>
);

export default IconMPR;
